import { render } from "./ForgotPasswordFormPopup.vue?vue&type=template&id=41cc932b&scoped=true&ts=true"
import script from "./ForgotPasswordFormPopup.vue?vue&type=script&lang=ts"
export * from "./ForgotPasswordFormPopup.vue?vue&type=script&lang=ts"

import "./ForgotPasswordFormPopup.vue?vue&type=style&index=0&id=41cc932b&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41cc932b"]])

export default __exports__